(function () {
  'use strict';

  const selector = '[data-xuibol-product-trust]';

  function updateTrustPrice(variantSelects) {
    const productView = variantSelects.closest('.productView');
    const trust = productView && productView.querySelector(selector);
    const output = trust && trust.querySelector('[data-xuibol-first-order-price]');
    const variant = variantSelects.currentVariant;

    if (!trust || !output || !variant || typeof variant.price !== 'number') return;

    const multiplier = Number(trust.dataset.discountMultiplier) || 0.8;
    const discountedPrice = Math.round(variant.price * multiplier);

    output.innerHTML = Shopify.formatMoney(discountedPrice, window.money_format);
    trust.dataset.variantId = variant.id;

    if (typeof Currency !== 'undefined' && (window.show_multiple_currencies || window.show_auto_currency)) {
      const activeCurrency = document.querySelector('.dropdown-item[data-currency].active');
      const currencyCode = activeCurrency && activeCurrency.getAttribute('data-currency');

      if (currencyCode && window.shop_currency && currencyCode !== window.shop_currency) {
        output.setAttribute('data-currency-' + window.shop_currency, output.innerHTML);
        Currency.convertAll(window.shop_currency, currencyCode, output, 'money_format');
      }
    }
  }

  function bindVariantSelects(element) {
    if (element.dataset.xuibolTrustBound === 'true') return;

    element.dataset.xuibolTrustBound = 'true';
    element.addEventListener('change', function () {
      requestAnimationFrame(function () {
        updateTrustPrice(element);
      });
    });
  }

  function init(root) {
    if (!root.querySelector(selector)) return;

    root.querySelectorAll('variant-selects, variant-radios').forEach(bindVariantSelects);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
